import { UrlParam } from '../models/urlParam.model';
import { getApiBaseUrl } from '../config/runtimeConfig';

export class BaseService {
  public static BuildUrl(subroute: string, ...params: UrlParam[]): string {
    let newUrl: string = getApiBaseUrl() + subroute;
    let firstParamAdded = false;

    params.forEach((param: UrlParam) => {
      if (param.value !== '') {
        if (!firstParamAdded) {
          newUrl += `?${param.name}=${param.value}`;
          firstParamAdded = true;
        } else {
          newUrl += `&${param.name}=${param.value}`;
        }
      }
    });
    return newUrl;
  }
}
